import { cloneDeep } from 'lodash';

import { defaultEventFilters } from '../defaultEventFilters.js';
import { getDefaultVideoAnalyticsFilters } from '../defaultVideoAnalyticsFilters.js';

const VIDEO_ANALYTIC_TYPES = ['bag', 'facecover', 'crowd', 'fight', 'weapon', 'fire', 'lying', 'handsup', 'fall'] as const;

const WORKSPACE_LOCATION_FILTER_FIELDS = ['cities', 'areas', 'districts', 'streets', 'house_numbers', 'origin_longitude', 'longitude_delta', 'origin_latitude', 'latitude_delta'] as const;

type VideoAnalyticType = typeof VIDEO_ANALYTIC_TYPES[number];

type WorkspaceFilterValue = unknown;

interface WorkspaceVideoAnalyticsFilter {
  isEnabled?: boolean;
  filters: Record<string, WorkspaceFilterValue>;
}

type WorkspaceVideoAnalyticsFilters = Record<
VideoAnalyticType,
WorkspaceVideoAnalyticsFilter
>;

interface WorkspaceFilters extends Record<string, WorkspaceFilterValue> {
  isEnabledDetectionAndMatchEvents: boolean;
  videoAnalytics: WorkspaceVideoAnalyticsFilters;
}

interface GetDefaultWorkspaceFiltersOptions {
  isVideoAnalyticsAvailable?: boolean;
  savedFilters?: Partial<WorkspaceFilters>;
}

function getDefaultWorkspaceFilters({
  isVideoAnalyticsAvailable = true,
  savedFilters = undefined,
}: GetDefaultWorkspaceFiltersOptions = {}): WorkspaceFilters {
  return cloneDeep({
    ...defaultEventFilters,
    ...getDefaultVideoAnalyticsFilters(isVideoAnalyticsAvailable),
    ...savedFilters,
  });
}

function resetWorkspaceEventFilters(
  filters: WorkspaceFilters,
  isVideoAnalyticsAvailable = true,
): WorkspaceFilters {
  const defaultFilters = getDefaultWorkspaceFilters({
    isVideoAnalyticsAvailable,
  });

  VIDEO_ANALYTIC_TYPES.forEach((analyticType) => {
    const isEnabled = filters.videoAnalytics?.[analyticType]?.isEnabled;
    if (isEnabled !== undefined) {
      defaultFilters.videoAnalytics[analyticType].isEnabled = isEnabled;
    }
  });

  defaultFilters.isEnabledDetectionAndMatchEvents = filters.isEnabledDetectionAndMatchEvents;

  return defaultFilters;
}

export {
  getDefaultWorkspaceFilters,
  resetWorkspaceEventFilters,
  VIDEO_ANALYTIC_TYPES,
  WORKSPACE_LOCATION_FILTER_FIELDS,
};

export type {
  GetDefaultWorkspaceFiltersOptions,
  VideoAnalyticType,
  WorkspaceFilterValue,
  WorkspaceFilters,
  WorkspaceVideoAnalyticsFilter,
  WorkspaceVideoAnalyticsFilters,
};
